import React, { useEffect, useState } from "react";
import useAuth from "../hooks/useAuth";
import useProcesoMatricula from "../hooks/useProcesoMatricula";
import { obtenerLabelEtiqueta } from "../utils/idioma/LabelsIdioma";

const ModalPDF = () => {
  let { seleccionPdf } = useProcesoMatricula();
 
  const {listadoEtiquetas } = useAuth();
  const [etiquetas, setEtiquetas] = useState({});

  let {ruta,title} = seleccionPdf;

  const sinArchivo = ruta === null || ruta === undefined || ruta === "";

  useEffect(() => {
  
    if (listadoEtiquetas.length > 0) {
      setEtiquetas({
        sumilla_aceptar: obtenerLabelEtiqueta(
          "lbl_sumilla_aceptar",
          listadoEtiquetas
        )
       
      });
    }
  }, [listadoEtiquetas]);
  const {  sumilla_aceptar } = etiquetas;

  return (
    <div
      className="modal fade"
      id="staticBackdrop"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabIndex={-1}
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-xl">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title text-uppercase" id="staticBackdropLabel">
              {title}
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div className="modal-body" style={{height: "60vh"}}>
            {sinArchivo ? (
              <div className="alert alert-warning mt-3" role="alert">
                <p className="mb-0" style={{ lineHeight: "1.2" }}>
                  <svg
                    style={{ width: 24, height: 24, marginRight: 5 }}
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="currentColor"
                      d="M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
                    />
                  </svg>
                  No hay archivo disponible para mostrar.
                </p>
              </div>
            ) : (
              <embed
                type="application/pdf"


                src={`${
                  String(ruta).includes("url")
                    ? "https://upch-segen-documentos.s3.amazonaws.com/NORMATIVA/REGLAMENTO+DEL+PROCESO+DE+ADMISION+AL+PREGRADO+A+LA+UPCH/RE-102-UPCH_V.02.00_2022.04.06.pdf"
                    : ruta
                }#zoom=96`}
                frameBorder={0}
                width="100%"
                height="100%"
              />
            )}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-primary"
              data-bs-dismiss="modal"
            >
              {sumilla_aceptar}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalPDF;
